// extracted by mini-css-extract-plugin
module.exports = {"crf_page":"crfPage_crf_page__38yeu","crf_content":"crfPage_crf_content__3_x2V"};